import React, {useState} from 'react';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import {Checkbox, FormControl, FormControlLabel, FormGroup, FormHelperText, Grid, Typography} from '@deere/fuel-react';
import {useStyles} from "../styles/Filter";

export const SupplierNumberAndUnits = ({ title, data, handleChange }) => {
  const [expanded, setExpanded] = useState(true)

  const classes = useStyles();

  const onChange = () => {
    setExpanded(!expanded)
  }
  const isDataChecked = () => {
    for(let item of data) {
      if ( item.checked ) {
        return true
      }
    }
    return false
  }

  return (
    <div className={classes.root}>
      <Accordion
        expanded={expanded}
        onChange={onChange}
      >
        <AccordionSummary
          className={classes.accordionSummary}
          classes={{ content: classes.content, expanded: classes.expanded }}
          expandIcon={<ExpandMoreIcon style={{ fontSize: '2rem' }} />}
          aria-controls="supplier-status"
          id="supplier-status"
        >
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography fontWeight="semibold">{title}</Typography>
            </Grid>
          </Grid>
        </AccordionSummary>
        <AccordionDetails className={classes.root}>
          <FormControl component="fieldset">
            {!isDataChecked() && (
              <FormHelperText error={true}>Select at least one</FormHelperText>
            )}
            <FormGroup>
              {data && data.map((supplierNumberObj, index) => {
                return (
                  <FormControlLabel key={index}
                                    className={classes.root}
                                    onChange={handleChange}
                                    control={<Checkbox checked={supplierNumberObj.checked} name={supplierNumberObj.id}/>}
                                    label={supplierNumberObj.description}/>
                )
              })}
            </FormGroup>
          </FormControl>
        </AccordionDetails>
      </Accordion>
    </div>
  );
};